let cache = null;

export function getBatchTabCache() {
  return cache;
}

export function setBatchTabCache(nextCache) {
  cache = nextCache;
}

export function clearBatchTabCache() {
  cache = null;
}
